import { put } from './requests'

const resourcePath = 'documentable_preferences'

export function updateDocumentablePreferences ({ id, ...documentablePreferences }) {
  return put(`${resourcePath}/${id}`, { documentablePreferences })
}
